import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';
import type {TranslationFunction} from 'src/types/language-support';
import {isTZBefore, wrangleMoment} from '../utils/date';
import type {IEvent} from '../types/IEvent';


export const selectCancellationPolicy = (
  state: IRootMachineSnapshot,
  t: TranslationFunction,
) => {
  const {timezone} = state.context;
  const eventDetails = state.context.eventDetails as IEvent;

  if (!eventDetails?.event_start) {
    return t('Event_not_found', 'Event not found');
  }

  const {event_start, did_cancellation_notice_pass, cancellation_policy} =
    eventDetails || {};

  if (!timezone) {
    return t('Event_not_found', 'Event not found');
  }

  const isEventInFuture = isTZBefore(
    new Date(),
    wrangleMoment(event_start),
    timezone,
  );

  if (cancellation_policy) {
    return cancellation_policy;
  }

  if (did_cancellation_notice_pass && !isEventInFuture) {
    return t(
      'This_meeting_does_not_exist_It_may_have_been_moved_or_deleted',
      'This meeting does not exist. It may have been moved or deleted.',
    );
  }

  if (did_cancellation_notice_pass && isEventInFuture) {
    return t(
      'This_meeting_is_too_close_to_cancel_using_the_link_Please_reach_out_to_the_host_directly',
      'This meeting is too close to cancel using the link. Please reach out to the host directly',
    );
  }

  return t('Cancel_period_is_over', 'Cancel period is over');
};

export const selectReason = (state: IRootMachineSnapshot) => {
  return state.context.reason;
};
